import OCGatewayClient from "../client/OCGatewayClient";
import { useMutation } from "@tanstack/react-query";

export interface CreateDevicePaymentPlanCheckoutSessionParams {
  deviceId: string;
  priceType: string;
  successUrl: string;
  cancelUrl: string;
}

export interface CheckoutSessionResponse {
  sessionId: string;
  url: string;
}

export function useCreateDevicePaymentPlanCheckoutSessionMutation() {
  const mutation = useMutation({
    mutationFn: async (params: CreateDevicePaymentPlanCheckoutSessionParams) => {
      const response = await OCGatewayClient.request('createDevicePaymentPlanCheckoutSession', {
        deviceId: params.deviceId,
        priceType: params.priceType,
        successUrl: params.successUrl,
        cancelUrl: params.cancelUrl
      });

      return response as CheckoutSessionResponse;
    }
  });

  return mutation;
}